import CognitoConfig from './_config'
import CognitoState from './_state'
import CognitoTokens from './_tokens'

const destinationKey = 'cognito-destination-url'

export default class CognitoUrls {
  public static get login() {
    const url = new URL(`${CognitoConfig.authUri}/oauth2/authorize`)
    url.searchParams.set('response_type', 'code')
    url.searchParams.set('client_id', CognitoConfig.clientId)
    url.searchParams.set('redirect_uri', CognitoConfig.redirectUri)
    url.searchParams.set('state', CognitoState.value)
    url.searchParams.set('scope', CognitoConfig.scope)
    return url.href
  }

  public static get logout() {
    const url = new URL(`${CognitoConfig.authUri}/logout`)
    url.searchParams.set('client_id', CognitoConfig.clientId)
    url.searchParams.set('logout_uri', CognitoConfig.redirectUri)
    url.searchParams.set('scope', CognitoConfig.scope)
    return url.href
  }

  public static get refresh() {
    const url = new URL(`${CognitoConfig.authUri}/oauth2/token`)
    url.searchParams.set('grant_type', 'refresh_token')
    if (CognitoTokens.refresh === null) {
      throw new Error('Unable to generate refresh URL: No refresh token found.')
    }
    url.searchParams.set('refresh_token', CognitoTokens.refresh)
    url.searchParams.set('client_id', CognitoConfig.clientId)
    url.searchParams.set('redirect_uri', CognitoConfig.redirectUri)
    url.searchParams.set('scope', CognitoConfig.scope)
    return url.href
  }

  public static get user() {
    return `${CognitoConfig.authUri}/oauth2/userInfo`
  }

  public static codeForToken(code: string) {
    const url = new URL(`${CognitoConfig.authUri}/oauth2/token`)
    url.searchParams.set('grant_type', 'authorization_code')
    url.searchParams.set('code', code)
    url.searchParams.set('client_id', CognitoConfig.clientId)
    url.searchParams.set('redirect_uri', CognitoConfig.redirectUri)
    url.searchParams.set('scope', CognitoConfig.scope)
    return url.href
  }

  public static get iscoutDestination() {
    const x = localStorage.getItem(destinationKey) || null
    return x
  }

  public static storeIscoutDestination(url: string) {
    const x = localStorage.setItem(destinationKey, url)
    return x
  }

  public static retrieveIscoutDestination() {
    const output = localStorage.getItem(destinationKey) || null
    localStorage.removeItem(destinationKey)
    return output
  }
}
